import React from "react"
import {findDOMNode} from "react-dom"

import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import Popover from "../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position"
import {FieldPopoverMenuProps} from "../../../dropdown/components/popover/popover-menu"
import FieldMultiselect_PopoverSearch from "../../../multiselect/components/popover/popover-search"
import FieldTags_PopoverTagsList from "./tags-list"

type State = {
    searchString?   : string
}

export default class FieldTags_PopoverMenu extends React.Component<FieldPopoverMenuProps,State> {

    public optionsSelector  : any
    public scroll           : any

    constructor(props:FieldPopoverMenuProps) {
        super(props);

        this.state = {
            searchString: undefined
        }
    }

    onPopoverKeyDown = (e:React.SyntheticEvent) => {if(this.optionsSelector) this.optionsSelector.onPopoverKeyDown(e)}

    onSearchChange = (newSearchString:string) => {
        this.setState({
            searchString: newSearchString
        })
    }

    updateScroll = (node:any) => {
        if (!this.scroll) return;

        const scrollNode : any = findDOMNode(this.scroll.childrenContainer)

        const nodeTop       = node.offsetTop
        const nodeBottom    = node.offsetTop + node.offsetHeight
        const scrollTop     = scrollNode.scrollTop
        const scrollBottom  = scrollNode.scrollTop + scrollNode.offsetHeight

        // ensure node to be in visible area of scroll
        if (scrollBottom < nodeBottom) this.scroll.setScrollTop(nodeBottom - scrollNode.offsetHeight, false, 100)
        else if (scrollTop > nodeTop) this.scroll.setScrollTop(nodeTop, false, 100)
    }

    render() {
        const isManager         = gd.ac.check.company.isManager()
        const PopoverMenuMore   = _.get(this.props.field.components, 'PopoverMenuMore', null)

        const popoverMenuClasses = Classes("ui5-popover-menu flex-column-left-top w-350 h-400", this.props.field.classes.PopoverMenu, {
            'with-help'     : isManager && PopoverMenuMore,
            'with-search'   : isManager && PopoverMenuMore,
        })

        const popoverPosition = new PopoverPosition({
            attachment      : "top center",
            targetAttachment: "bottom center",
        })

        return (
            <Popover position         = {popoverPosition}
                     getTargetFunc      = {()=>findDOMNode(this.props.parent)}
                     onKeyDown          = {this.onPopoverKeyDown}
                     onClickOutside     = {()=>{this.props.parent.hidePopover()}}>
                <div className={popoverMenuClasses}>
                    <FieldMultiselect_PopoverSearch className       = "w-100-percent"
                                                    searchable      = {true}
                                                    searchString    = {this.state.searchString}
                                                    onHidePopover   = {this.props.parent.hidePopover}
                                                    onSearchChange  = {this.onSearchChange}/>

                    <VScroll minDragHeight      = {20}
                             containerClass     = {this.props.field.classes.PopoverMenuScrollContainer}
                             scrollVisibility   = "auto">
                        <FieldTags_PopoverTagsList {...this.props} searchString={this.state.searchString} />

                        {isManager && <PopoverMenuMore {...this.props}/> }
                    </VScroll>
                </div>
            </Popover>
        )
    }
}